/**
 * Get the data key for displayed modal
 * @return null | string
 */

 const getDisplayedModalDataKey = state => state.modal.displayedModalDataKey;

 export default getDisplayedModalDataKey;
 
 